import * as React from "react";

import { MapaOperacoes } from "@/components/mapa/MapaOperacoes";
import { DocumentosUnidade } from "@/components/operacoes/DocumentosUnidade";
import { Skeleton } from "@/components/ui/skeleton";
import { useUnidades } from "@/hooks/queries";
import type { Unidade } from "@/types";

export function EmpresasFsPage() {
  const { data, isLoading } = useUnidades();
  const [selecionada, setSelecionada] = React.useState<Unidade | null>(null);

  if (isLoading || !data) {
    return (
      <div className="grid gap-5 lg:grid-cols-[minmax(0,1fr)_21rem]">
        <Skeleton className="h-[34rem] w-full" />
        <Skeleton className="h-[22rem] w-full" />
      </div>
    );
  }

  return (
    <div className="space-y-5">
      <MapaOperacoes dados={data} selecionada={selecionada} onSelecionar={setSelecionada} />
      <DocumentosUnidade
        unidade={selecionada ? `${selecionada.emp}-${selecionada.centro}` : null}
      />
    </div>
  );
}
